import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const EntryQuisioner = () => {
  const { id } = useParams<{ id: string }>(); // presiden_id
  const token = Cookies.get("token");

  const [loading, setLoading] = useState(true);
  const [quisioners, setQuisioners] = useState<any[]>([]);
  const [newQuestions, setNewQuestions] = useState<string[]>([""]); // input multiple pertanyaan
  const [editedValues, setEditedValues] = useState<{ [key: number]: string }>({}); // state edit per quisioner

  // Fetch quisioner list
  const fetchQuisioners = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/presidens/${id}/quisioners`, { headers: { Authorization: `Bearer ${token}` } });
      setQuisioners(res.data.quisioners || []);

      // reset edited values setiap fetch
      const initialValues: { [key: number]: string } = {};
      res.data.quisioners.forEach((q: any) => {
        initialValues[q.id] = q.pertanyaan;
      });
      setEditedValues(initialValues);
    } catch (err) {
      console.error("Gagal fetch quisioners:", err);
      Swal.fire("Error", "Gagal memuat data quisioner.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchQuisioners();
  }, [id, token]);

  // Tambah banyak pertanyaan
  const handleAddQuisioner = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/presidens/${id}/quisioners`, { pertanyaan: newQuestions.filter((q) => q.trim() !== "") }, { headers: { Authorization: `Bearer ${token}` } });
      Swal.fire("Berhasil", "Quisioner berhasil ditambahkan!", "success");
      setNewQuestions([""]);
      fetchQuisioners();
    } catch (err) {
      console.error("Gagal tambah quisioner:", err);
      Swal.fire("Error", "Gagal menambahkan quisioner.", "error");
    }
  };

  // Update satu quisioner
  // Update satu quisioner
  const handleUpdateQuisioner = async (qid: number) => {
    try {
      const updated = {
        quisioners: [
          {
            id: qid,
            pertanyaan: editedValues[qid],
          },
        ],
      };

      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/quisioners/${qid}`, updated, { headers: { Authorization: `Bearer ${token}` } });

      Swal.fire("Berhasil", "Quisioner berhasil diperbarui!", "success");
      fetchQuisioners();
    } catch (err) {
      console.error("Gagal update quisioner:", err);
      Swal.fire("Error", "Gagal memperbarui quisioner.", "error");
    }
  };

  // Hapus quisioner
  const handleDeleteQuisioner = async (qid: number) => {
    Swal.fire({
      title: "Hapus Quisioner?",
      text: "Data yang dihapus tidak bisa dikembalikan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/quisioners/${qid}`, { headers: { Authorization: `Bearer ${token}` } });
          Swal.fire("Berhasil", "Quisioner berhasil dihapus!", "success");
          fetchQuisioners();
        } catch (err) {
          console.error("Gagal hapus quisioner:", err);
          Swal.fire("Error", "Gagal menghapus quisioner.", "error");
        }
      }
    });
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );

  return (
    <div className="mt-6 max-w-3xl mx-auto border rounded-sm shadow-sm p-4">
      <Link to={`/dashboard/presiden-detail/${id}`}>
        <div className="flex items-center gap-3 mb-4">
          <IoArrowBack />
          <h1 className="text-xl font-medium">Manajemen Quisioner</h1>
        </div>
      </Link>

      {/* Form tambah quisioner */}
      <div className="mb-6">
        <h2 className="font-semibold mb-2">Tambah Pertanyaan Baru</h2>
        {newQuestions.map((q, idx) => (
          <input
            key={idx}
            type="text"
            value={q}
            onChange={(e) => {
              const copy = [...newQuestions];
              copy[idx] = e.target.value;
              setNewQuestions(copy);
            }}
            placeholder={`Pertanyaan ${idx + 1}`}
            className="border p-2 w-full mb-2 rounded"
          />
        ))}
        <div className="flex gap-2">
          <button type="button" onClick={() => setNewQuestions([...newQuestions, ""])} className="px-3 py-1 bg-gray-200 rounded">
            + Tambah Input
          </button>
          <button type="button" onClick={handleAddQuisioner} className="px-4 py-2 bg-primary text-white rounded">
            Simpan Pertanyaan
          </button>
        </div>
      </div>

      {/* List quisioner */}
      <div>
        <h2 className="font-semibold mb-2">Daftar Quisioner</h2>
        {quisioners.length === 0 ? (
          <p>Belum ada quisioner.</p>
        ) : (
          <ul className="space-y-3">
            {quisioners.map((q) => (
              <li key={q.id} className="border p-3 rounded shadow-sm">
                <input
                  type="text"
                  value={editedValues[q.id] || ""}
                  onChange={(e) =>
                    setEditedValues({
                      ...editedValues,
                      [q.id]: e.target.value,
                    })
                  }
                  className="border p-2 w-full mb-2 rounded"
                />
                <div className="flex justify-between items-center">
                  <div className="flex gap-3 text-sm text-gray-600 mb-1">
                    <div className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-medium">
                      Rata-rata: <span className="font-bold">{q.avg_nilai}</span>
                    </div>
                    <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-medium">Vote: {q.total_vote}</div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => handleUpdateQuisioner(q.id)}
                      disabled={editedValues[q.id] === q.pertanyaan}
                      className={`px-3 py-1 rounded text-sm ${editedValues[q.id] !== q.pertanyaan ? "bg-yellow-500 text-white hover:bg-yellow-600" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
                      Simpan Perubahan
                    </button>
                    <button onClick={() => handleDeleteQuisioner(q.id)} className="text-red-500 text-sm hover:underline">
                      Hapus
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default EntryQuisioner;
